<template>
  <main class="checkout-purchase"
    :class="{'show-steps': !status.finished}"
  >
    <snackbar
      v-if="snackbar.show"
      :error="snackbar.error"
      :success="snackbar.success"
      :message="snackbar.message"
      @close="resetSnackbar"
    />
    <transition name="fade">
      <checkout-result-step
        v-if="status.finished"
        :errorCode="status.errorCode"
        :kidList="kidList"
        @restartPayment="restartPayment"
      />
    </transition>

    <transition name="fade">
    <steps-screen
      v-if="!status.finished"
      class="checkout-purchase__content"
    >
      <stepper
        class="checkout-stepper"
        slot="stepper"
        @click="goToStepSection"
        :steps="steps"
      />
      <checkout-register-kid-step
        id="checkout-register-kid"
        ref="checkoutRegisterKid"
        :kidList="kidList"
        @registerKidProfile="registerKidProfile"
        @updateKidProfile="updateKidProfile"
        @removeKidProfile="removeKidProfile"
        class="flow-step"
      />
      <checkout-choose-plan-step
        id="checkout-choose-plan"
        :offer="offer"
        :plan="plan"
        @invalidCoupon="invalidCoupon"
        @planChosen="planChosen"
        class="flow-step"
      />
      <checkout-payment-step
        id="checkout-payment"
        :processing="status.processing"
        :coupon="null"
        :plan="plan"
        :credentialKey="credentialKey()"
        @subscriptionCreationRequested="subscriptionCreationRequested"
        class="flow-step"
      />
    </steps-screen>
    </transition>
  </main>
</template>

<script>
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
// import peanutbutterAPI from '@/api/peanutbutter'
import sabAPI from '@/api/sab'
import vindiAPI from '@/api/vindi'
import { Notification } from '@/js/Notification'

const CheckoutStepMap = {
  checkoutRegisterKid: { id: 'checkout-register-kid', title: 'Dados da Criança' },
  checkoutChoosePlan: { id: 'checkout-choose-plan', title: 'Escolha seu plano' },
  checkoutPayment: { id: 'checkout-payment', title: 'Pagamento' }
}
const INVALID_COUPON_ERROR = 4

export default {
  name: 'checkout-purchase',
  props: {
    offer: String
  },
  data: () => ({
    notification: new Notification(),
    status: {
      processing: false,
      finished: false,
      errorCode: 0
    },
    snackbar: {
      show: false,
      message: '',
      error: false,
      success: false
    },
    kidList: [],
    plan: null,
    steps: [
      { ...CheckoutStepMap.checkoutRegisterKid, done: false, selected: true, error: false },
      { ...CheckoutStepMap.checkoutChoosePlan, done: false, selected: false, error: false },
      { ...CheckoutStepMap.checkoutPayment, done: false, selected: false, error: false }
    ],
    subscriptionCreationError: null
  }),
  methods: {
    ...mapState({
      accountId: state => state.user.accountId,
      credentialKey: state => state.user.credentialKey
    }),
    ...mapActions({ verifyProfile: 'user/verifyProfile' }),
    async registerKidProfile(payload) {
      try {
        await sabAPI.createChildProfile({
          name: payload.name,
          birthday: moment(payload.birthDate).format('YYYY-MM-DD'),
          character_id: 5
        })
        await this.loadChildrenProfiles()
        this.snackbar = {
          show: true,
          message: this.$t('checkout.registerKid.form.successCreateMessage', { name: payload.name }),
          success: true,
          error: false
        }
        this.$refs.checkoutRegisterKid.resetKidProfileForm()
      } catch (error) {
        this.snackbar = {
          show: true,
          message: this.$t('checkout.registerKid.form.errorCreateMessage', { name: payload.name }),
          success: false,
          error: true
        }
      } finally {
        this.$refs.checkoutRegisterKid.finishProcessing()
      }
    },
    async updateKidProfile(payload) {
      try {
        await sabAPI.updateChildProfile(payload.id, {
          name: payload.name,
          birthday: moment(payload.birthDate).format('YYYY-MM-DD')
        })
        await this.loadChildrenProfiles()
        this.snackbar = {
          show: true,
          message: this.$t('checkout.registerKid.form.successUpdateMessage', { name: payload.name }),
          success: true,
          error: false
        }
        this.$refs.checkoutRegisterKid.resetKidProfileForm()
      } catch (error) {
        this.snackbar = {
          show: true,
          message: this.$t('checkout.registerKid.form.errorUpdateMessage', { name: payload.name }),
          success: false,
          error: true
        }
      } finally {
        this.$refs.checkoutRegisterKid.finishProcessing()
      }
    },
    async removeKidProfile(payload) {
      try {
        await sabAPI.removeChildProfile(payload.id)
        this.$refs.checkoutRegisterKid.resetRemoveModal()
        this.snackbar = {
          show: true,
          message: this.$t('checkout.registerKid.form.successDeleteMessage', { name: payload.name }),
          success: true,
          error: false
        }
        await this.loadChildrenProfiles()
      } catch (error) {
        this.snackbar = {
          show: true,
          message: this.$t('checkout.registerKid.form.errorDeleteMessage', { name: payload.name }),
          success: false,
          error: true
        }
      } finally {
        this.$refs.checkoutRegisterKid.finishProcessing()
      }
    },
    planChosen(plan) {
      this.plan = plan
      this.updateStepState(CheckoutStepMap.checkoutChoosePlan.id, {
        done: true, selected: false, error: false
      })
    },
    invalidCoupon() {
      this.status = {
        finished: true,
        errorCode: INVALID_COUPON_ERROR
      }
    },
    selectStepSection(id) {
      const newSteps = [...this.steps]
      newSteps.forEach(it => {
        if (it.id === id) {
          it.selected = true
        } else {
          it.selected = false
        }
      })
      this.steps = [...newSteps]
    },
    goToStepSection(id) {
      document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: 'start' })
    },
    updateStepState(id, state) {
      const newSteps = this.steps.map(it => {
        if (it.id === id) {
          return { ...it, ...state }
        }
        return it
      })
      this.steps = [...newSteps]
    },
    hasViolation() {
      let stepSectionViolation = null
      if (!this.kidList.length) {
        this.updateStepState(CheckoutStepMap.checkoutRegisterKid.id, {
          done: false, selected: false, error: true
        })
        stepSectionViolation = CheckoutStepMap.checkoutRegisterKid.id
      }
      if (!this.plan) {
        this.updateStepState(CheckoutStepMap.checkoutChoosePlan.id, {
          done: false, selected: false, error: true
        })
        if (!stepSectionViolation) {
          stepSectionViolation = CheckoutStepMap.checkoutRegisterKid.id
        }
      }

      if (stepSectionViolation) {
        this.goToStepSection(stepSectionViolation)
        return true
      }
      return false
    },
    async subscriptionCreationRequested(payload) {
      if (this.hasViolation()) return

      this.status.processing = true
      this.resetSnackbar()
      this.notification.clear()

      try {
        const { sku, planIdVindi: vindiPlanId } = this.plan
        // let coupon = this.$route.query.coupon ? this.formatCoupon(this.$route.query.coupon) : null

        // 1. Criação do usuário
        const userResponse = await this.createVindiUser(payload, sku)

        // 2. Criação do perfil de pagamento
        const paymentProfile = userResponse ? await this.createPaymentProfile(payload.card) : null

        // 3. Inscrição do usuário
        if (paymentProfile) {
          await this.subscribeVindiUser(paymentProfile, vindiPlanId)
        }

        if (this.notification.hasErrors()) {
          this.handleNotificationErrors(this.notification)
        } else {
          await this.finalizeSubscription()
          this.status = { finished: true, errorCode: 0 }
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.status.processing = false
      }
    },
    async createVindiUser(payload, sku) {
      try {
        const response = await sabAPI.createVindiUser(payload.email, sku, payload.card, payload.billing)
        if (response === false) {
          this.notification.addError(this.$t('checkout.registerKid.form.errorCardInfo'))
        } else {
          this.notification.addSuccess('User registered successfully')
        }
        return response
      } catch (error) {
        this.handleError(new Error('Failed to register user'))
        return null
      }
    },
    async createPaymentProfile(card) {
      try {
        const response = await vindiAPI.createPaymentProfile(card, 51)
        if (response === false) {
          this.notification.addError(this.$t('checkout.registerKid.form.errorCardInfo'))
        } else {
          this.notification.addSuccess('Payment profile created successfully')
        }
        return response
      } catch (error) {
        this.handleError(new Error('Failed to create payment profile'))
        return null
      }
    },
    async subscribeVindiUser(paymentProfile, vindiPlanId) {
      try {
        const response = await sabAPI.subscribeVindiUser(paymentProfile.payment_profile.gateway_token, vindiPlanId)
        if (response === false) {
          this.notification.addError(this.$t('checkout.registerKid.form.errorCardInfo'))
        } else {
          this.notification.addSuccess('User subscribed successfully')
        }
        return response
      } catch (error) {
        this.handleError(new Error('Failed to subscribe user to Vindi'))
        return null
      }
    },
    async finalizeSubscription() {
      await this.verifyProfile()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    formatCoupon(coupon) {
      return coupon.replace(/ /g, '+')
    },
    handleNotificationErrors(notification) {
      // Exibe todas as mensagens de erro acumuladas
      notification.getErrors().forEach(error => {
        console.error(error)
      })
      // Exibe no snackbar (ou outro componente) as mensagens de erro
      this.snackbar = {
        show: true,
        message: notification.getErrors().join(', '),
        success: false,
        error: true
      }
    },
    handleError(error) {
      console.error(error.message)

      if (error.code === 400 && error.body && error.body.code) {
        this.snackbar = {
          show: true,
          message: error.body.code,
          success: false,
          error: true
        }
      } else {
        this.status = { finished: true, errorCode: error.code || 500 }
      }
    },
    restartPayment() {
      this.status = {
        processing: false,
        finished: false,
        errorCode: 0
      }
    },
    resetSnackbar() {
      this.snackbar = {
        show: false,
        message: ``,
        success: false,
        error: false
      }
    },
    async loadChildrenProfiles() {
      const response = await sabAPI.getAllChildrenProfiles()
      const data = await response.json()

      this.kidList = Object.values(data.profiles).map(it => ({ id: it.id, name: it.name, birthDate: it.birthday }))
      if (this.kidList.length) {
        this.updateStepState(CheckoutStepMap.checkoutRegisterKid.id, {
          done: true
        })
      } else {
        this.updateStepState(CheckoutStepMap.checkoutRegisterKid.id, {
          done: false
        })
      }
    },
    onWindowScroll() {
      var registerKidSectionPosition = document.querySelector('#checkout-register-kid').getBoundingClientRect()
      var choosePlanSectionPosition = document.querySelector('#checkout-choose-plan').getBoundingClientRect()
      var paymentSectionPosition = document.querySelector('#checkout-payment').getBoundingClientRect()

      if (registerKidSectionPosition.top >= 0 && registerKidSectionPosition.bottom <= window.innerHeight) {
        this.selectStepSection('checkout-register-kid')
      }
      if (choosePlanSectionPosition.top >= -100 && choosePlanSectionPosition.bottom <= (window.innerHeight + 100)) {
        this.selectStepSection('checkout-choose-plan')
      }
      if ((paymentSectionPosition.top + 600) < window.innerHeight && paymentSectionPosition.bottom >= 0) {
        this.selectStepSection('checkout-payment')
      }
    }
  },
  created() {
    window.addEventListener('scroll', this.onWindowScroll)
    this.loadChildrenProfiles()
  },
  destroyed() {
    window.removeEventListener('scroll', this.onWindowScroll)
  }
}
</script>

<style lang="scss">
.checkout-purchase {
  position: relative;
  margin-top: 0;

  &.show-steps {
    background-image: url('~@/assets/checkout/section-1.png'), url('~@/assets/checkout/section-2.png');
    background-repeat: no-repeat;
    background-size: 1440px 749px, 1440px 1018px;
    background-position: -50rem 0, -50rem 35rem;
  }
}
@media screen and (min-width: 641px) {
  .checkout-purchase {
    &.show-steps {
      background-position: -30rem 0, -30rem 40rem;
    }
  }
}
@media screen and (min-width: 769px) {
  .checkout-purchase {
    &.show-steps {
      background-position: -30rem 8rem, -10rem 52rem;
    }
  }
}
@media screen and (min-width: 1281px) {
  .checkout-purchase {
    &.show-steps {
      background-position: -25rem 12rem, 0 54rem;
    }
  }
}
</style>
